<template>
  <Form
    ref="areaForm"
    :model="queryData"
    inline
    :label-width="125"
    class="form-common"
  >
    <Row>
      <FormItem
        label="条码"
        prop="skuCode"
      >
        <Input
          v-model="queryData.skuCode"
          placeholder="请输入条码"
        ></Input>
      </FormItem>
      <FormItem
        label="产品名称"
        prop="skuCode"
      >
        <Input
          v-model="queryData.skuName"
          placeholder="产品名称"
        ></Input>
        <!-- <AutoComplete
          clearable
          v-model="queryData.skuName"
          :data="skuNameList"
          @on-change="onSkuNameChange"
          :filter-method="remoteMethod2"
          placeholder="请输入条码"
          style="width:200px"
        >
        </AutoComplete> -->
      </FormItem>
      <FormItem
        label="批次号"
        prop="pici"
      >
        <Input
          v-model="queryData.pici"
          placeholder="请输入批次号"
        ></Input>
      </FormItem>
    </Row>
    <FormItem class="btn-groups">
      <Button
        type="primary"
        @click="handleQuery"
      >查询</Button>
      <!--<Button type="default" @click="handleReset('areaForm')">重置</Button>-->
      <!-- <Button
        type="default"
        @click="clickInsert"
      >新增</Button> -->
    </FormItem>
  </Form>
</template>

<script>
import SkuInput from '@/components/SkuInput/index.vue'
export default {
  name: 'QueryForm',
  components: {
    SkuInput
  },
  computed: {
    skuNames () {
      return _.map(this.skuOptions,({skuName}) => skuName)
    }
  },
  data () {
    return {
      skuCodeLoading: false,
      skuOptions: [{}],
      sku2Options: [],
      skuNameList: [],
      queryData: {
        skuName: '',
        skuCode: '',
        pici: '',
      }
    }
  },
  async mounted () {
    await this.initSkuName()
  },
  methods: {
    async initSkuName () {
      const {data}=await this.$fetch('CusFahuo/selectListForSearch',{
      },'GET')
      this.skuOptions=data
    },
    handleQuery () {
      this.$emit('on-query',this.queryData)
    },
    setQueryData (data) {
      this.queryData=data
    },
    clickInsert () {
      this.$emit('on-insert')
    },
    remoteMethod1 (query) {

    },
    onSkuNameChange (val) {
      if(query!=='') {
        this.skuCodeLoading=true;
        this.$fetch('CusFahuo/selectListForSearch',{
          skuCode: query
        },'GET')
          .then(res => {
            this.skuOptions=res.data
            this.skuCodeLoading=false
          })

      } else {
        this.skuOptions=[];
      }
      this.skuNameList=_.map(this.skuOptions,({skuName}) => skuName)
      console.log(this.skuNameList)
    },
    remoteMethod2 (query,options) {
      return this.skuNameList.some(this.skuNameList,(item) => item.indeOf(query)!==-1)
    },
    remoteMethod3 (query) {
      if(query!=='') {
        this.skuCodeLoading=true;
        this.$fetch('CusFahuo/selectListForSearch',{
          pici: query,
          skuCode: this.queryData.skuCode
        },'GET')
          .then(res => {
            this.sku2Options=_.uniqBy(res.data,({pici}) => pici);
            this.skuCodeLoading=false
          })

      } else {
        this.sku2Options=[];
      }
    },
  }
}
</script>
